const trackDisplayValidator = value => value !== 'disabled'

export default {
  /**
   * The options array, it can either be an array of objects, in which
   * case the trackBy/displayBy props are necessary, or an array of any
   * other primitive type.
   */
  options: {
    type: Array,
    required: true
  },

  /**
   * The input name.
   */
  name: {
    type: String,
    default: 'select'
  },

  /**
   * If `options` is an array of objects, CSelect will use this prop
   * to compare the currently select item.
   */
  trackBy: {
    type: String,
    validator: trackDisplayValidator,
    default: '',
  },

  /**
   * If `options` is an array of objects, CSelect will use this prop
   * to get the label of the option/value to be displayed for the user.
   */
  displayBy: {
    type: String,
    validator: trackDisplayValidator,
    default: '',
  },

  /**
   * The icon to show field.
   */
  icon: {
    type: String,
    default: '',
  },

  /**
   * The size of said icon
   */
  iconSize: {
    type: [ String, Number ],
    default: 20
  },

  /**
   * The icon of the dropdown indicator (the little arrow on the left).
   */
  selectIcon: {
    type: String,
    default: 'chevron-down'
  },

  /**
   * The placeholder of the field.
   */
  placeholder: {
    type: String,
    default: 'Selecione uma opção'
  },

  /**
   * The value of the field.
   */
  value: {
    type: [ Array, Object, String, Number, Boolean ],
    default: null,
  },

  /**
   * The field validation rules
   */
  fieldRules: {
    type: Object,
    default: () => ({}),
  },

  /**
   * The field name
   */
  fieldName: {
    type: String,
    default: ''
  },

  /**
   * Disables the field
   */
  disabled: Boolean,

  /**
   * Paginates the option list.
   */
  paginated: Boolean,

  /**
   * Toggle the alternative style.
   */
  alternative: Boolean,

  /**
   * Uses native input on mobile devices.
   */
  mobileNative: {
    type: Boolean,
    default: true
  },

  /**
   * Determines how many items to show at a time, only relevant
   * when the `paginated` prop is set to `true`.
   */
  paginationThreshold: {
    type: [ Number, String ],
    default: 10
  },

  /**
   * Allows the user to deselect the currently selected option
   */
  nullable: Boolean,

  error: Boolean,

  required: Boolean,

  /**
   * The select component will $emit just the trackBy value when true
   */
  emitTrackedValue: Boolean,

  /**
   * Defines whether a single option can be auto selected
   * (fieldRules.required === true also enables this behavior)
   */
  autoSelectSingle: Boolean,

  /**
   * Prevents the dropdown from closing when an option is selected
   */
  preventCloseOnSelect: Boolean,

  /**
   * Default icon for options when they don't have their own icon
   */
  optionIcon: {
    type: String,
    default: ''
  },

  /**
   * Size of option icon
   */
  optionIconSize: {
    type: [ String, Number ],
    default: 16
  },

  /**
   * The input tabindex value
   */
  tabindex: {
    type: Number,
    default: 0
  },

  /**
    * If true, the select will show a custom button to add options.
    */
  hasAddBtnOption: {
    type: Boolean,
    default: false
  },
  /**
    * The text to be displayed on the custom add option button.
    */
  customAddBtnText: {
    type: String,
    default: 'Adicionar nova opção'
  },

  /**
    * If true, the items on select will show a custom button to options.
    */
  hasItemBtnOption: {
    type: Boolean,
    default: false
  },

  /**
   * Determines whether an empty option should be shown in the abilities list.
   * When set to true, an empty selectable option will be displayed.
   *
   * @type {boolean}
   * @default false
   */
  habilityEmptyOption: {
    type: Boolean,
    default: false
  },

  /**
   * When true, keeps all options available even if already selected.
   * No filtering is applied based on current selection.
   *
   * @type {boolean}
   * @default false
   */
  keepAllOptionsAvailable: {
    type: Boolean,
    default: false
  }
}
